import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const WriteAWillIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M1.4 44.5c0 1.6 1.3 2.9 2.9 2.9h27c1.6 0 2.9-1.3 2.9-2.9V15.2c0-1.6-.9-3.8-2-5l-5-5.5c-1.1-1.2-3.3-2.1-4.8-2.1h-18c-1.6 0-2.9 1.3-2.9 2.9v39z"
        fill="#ffffff"
        className={styles.white}
      />
      <path
        d="M1.4 44.5c0 1.6 1.3 2.9 2.9 2.9h27c1.6 0 2.9-1.3 2.9-2.9V15.2c0-1.6-.9-3.8-2-5l-5-5.5c-1.1-1.2-3.3-2.1-4.8-2.1h-18c-1.6 0-2.9 1.3-2.9 2.9v39z"
        fill="none"
        stroke="#000000"
        className={styles.defaultStrokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M25.2 2.6v8c0 1 .8 1.7 1.7 1.7h7.2"
        fill="none"
        stroke="#000000"
        className={styles.defaultStrokeColor}
        strokeMiterlimit="10"
      />
      <path
        d="m25.274 32.907 19.024-19.018 2.333 2.333-19.024 19.019zM44.34 13.834l2.546-2.546 2.334 2.333-2.546 2.546zM24.6 37.3l1.9-.9-2.3-2.4-1 2z"
        fill="#E81C30"
        className={styles.accentColor}
      />
      <path d="m23.2 36-1.3 2.7 2.8-1.5z" fill="#E81C30" className={styles.accentColor} />
      <path
        d="M7.6 16.8h18.9M7.6 26.9h18.9M7.6 31.8h12.2M7.6 21.8h18.9"
        fill="none"
        stroke="#000000"
        className={styles.defaultStrokeColor}
        strokeMiterlimit="10"
      />
      <path
        d="M7.1 41.6c1.6-1.6 3.1-3.1 4.5-4.9.4-.3-.6.2-.9.1-.2-.1-.1.4-.1.6 0 1.8-1.8 3.9-1 5.6 1.9.7 3.4-2 5.4-1.8-.3-.1-.5-.1-.8-.2 1.5 4.5 4.4-.3 5.2-.7.6.2 2-.8.7-.9-1.2-.6-5.8 3.7-3.3 2.6-.4-.4-.8-.9-.9-1.5-1.7-.6-4.3.7-5.7 1.8 0 0 .8.1.9-.1 0-1.9 1.2-3.6 1.2-5.4-1.3-3.2-5.4 3.9-7 4.8-.2.8 1.5.4 1.8 0z"
        fill="#000000"
        className={styles.defaultColor}
      />
    </Icon>
  )
}
